module.exports = __webpack_public_path__ + "img/icon_space.3df55156.svg";